import React, { useContext, useEffect } from "react";
import { IdentityContext } from "@react-beets/identity";
import { Route, Redirect, useLocation } from "react-router-dom";
import { ROUTES } from "../../../constants";
import Loading from "../../../components/Loading";

const PrivateRoute = ({ component: Component, path, loading }) => {
  const { isAuthenticated } = useContext(IdentityContext);
  const location = useLocation();
  if (!loading && location.pathname === ROUTES.WEBSITE_HOME && isAuthenticated) {
    Component = Pages.AppHome
  }

  return (
    <>
      {!loading && <Route
        exact
        path={path}
        render={(props) =>
          isAuthenticated === true ? (
            <Component {...props}/>
          ) : (
            <Redirect
              to={{
                pathname: ROUTES.WEBSITE_HOME,
                state: { from: props.location },
              }}
            />
          )
        }
      />}
      {loading &&  <Loading />}
    </>
  );
};

export default PrivateRoute;
